import CreateUser from './Create';
export default CreateUser;